import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12b18e4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = {
  key: 0,
  class: "animate-pulse mx-2 p-2 mb-2 flex flex-col gap-y-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-full bg-gray-200 rounded col-span-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-full bg-gray-200 rounded col-span-1" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "advisoryShortDescCt"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-1 opacity-50" }, "What this is:", -1))
const _hoisted_8 = { class: "placeListItem" }

import { getLayersInformation } from '@/services/layers.services';
import { ref, watchEffect } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvisoryList',
  props: {
    layerData: null,
    isVisible: { type: Boolean },
    layerKey: null
  },
  emits: ["onPlaceClick", "onReadMore"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'onPlaceClick', properties: any): void;
  (event: 'onReadMore', e: MouseEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { layerData: any[]; isVisible: boolean; layerKey: string }



const recommendedAdvisory = ref();
const loading = ref(false);

const fetchRecommendedAdvisrory = async () => {
  loading.value = true;
  const result = await getLayersInformation({ layerCategoryId: props.layerKey });
  if (result.data.success) {
    recommendedAdvisory.value = result.data.layer.recommended_advisory;
  }
  loading.value = false;
};

watchEffect(() => {
  // fetch recommended advisory if layer toggled open
  // and it is not already fetched
  if (props.isVisible && !recommendedAdvisory.value) {
    fetchRecommendedAdvisrory();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(recommendedAdvisory.value) + " ", 1),
            _createElementVNode("button", {
              class: "inline text-blue-500 hover:underline cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onReadMore', $event)))
            }, " Read More... ")
          ])
        ])),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.layerData, (properties) => {
      return (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(properties.name ?? 'N/A'), 1))
    }), 256))
  ]))
}
}

})